import { useState, useRef } from 'react';
import { uploadCertificate, certificateUrl } from '../lib/justify';

// Adjuntar un certificado (PDF o foto). Sube el archivo apenas se elige.
export function CertificateField({ orgId, employeeId, value, onChange, label = 'Certificado (opcional)', required = false }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const ref = useRef(null);
  const pick = async (e) => {
    const f = e.target.files?.[0]; e.target.value = '';
    if (!f) return;
    setBusy(true); setErr('');
    try { onChange(await uploadCertificate(orgId, employeeId, f)); }
    catch (ex) { setErr(ex.message); }
    setBusy(false);
  };
  return (
    <div>
      <label className="block text-xs font-bold text-gray-500 mb-1.5 uppercase tracking-wide">{required ? 'Certificado (obligatorio)' : label}</label>
      {value ? (
        <div className="flex items-center justify-between gap-2 rounded-2xl border border-emerald-200 bg-emerald-50 px-3.5 py-2.5">
          <span className="text-xs font-semibold text-emerald-700 truncate">Archivo adjunto</span>
          <span className="flex gap-3 flex-shrink-0">
            <CertificateLink path={value} className="text-xs font-bold text-emerald-700 underline" />
            <button type="button" onClick={() => onChange(null)} className="text-xs font-bold text-gray-500">Quitar</button>
          </span>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current?.click()} disabled={busy}
          className="w-full rounded-2xl border-2 border-dashed border-gray-200 px-4 py-3 text-xs font-bold text-gray-500 hover:border-sky-300 hover:text-sky-700 disabled:opacity-60">
          {busy ? 'Subiendo…' : 'Adjuntar PDF o foto (hasta 5 MB)'}
        </button>
      )}
      <input ref={ref} type="file" accept="application/pdf,image/png,image/jpeg,image/webp" onChange={pick} className="hidden" />
      {err && <p className="text-xs text-red-500 mt-1.5">{err}</p>}
    </div>
  );
}

export function CertificateLink({ path, className = 'text-xs font-bold text-sky-700 underline', children = 'Ver certificado' }) {
  const [busy, setBusy] = useState(false);
  if (!path) return null;
  const open = async () => {
    setBusy(true);
    try { window.open(await certificateUrl(path), '_blank', 'noopener'); } catch (e) { window.alert(e.message); }
    setBusy(false);
  };
  return <button type="button" onClick={open} disabled={busy} className={className}>{busy ? 'Abriendo…' : children}</button>;
}
